import { render, staticRenderFns } from "./wordpress-plugin-page.vue?vue&type=template&id=4cb8c5e2&scoped=true"
import script from "./wordpress-plugin-page.vue?vue&type=script&lang=js"
export * from "./wordpress-plugin-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb8c5e2",
  null
  
)

export default component.exports